module.exports = __webpack_public_path__ + "static/ML_hero-Products-bb854e018ced2071adaeac5c689db3de.jpg";